import Poll from "../poll/Poll";

class Menu {
    men_id: string | null | undefined
    men_name: string | null | undefined
    men_business_id: string | null | undefined
    men_created: Date
    men_created_by: string | null | undefined
    men_active: boolean
    men_default: boolean
    men_sync_id: string | null | undefined
    men_font_family: string | null | undefined
    men_primary_color: string | null | undefined
    men_background_color: string | null | undefined
    men_text_align: string | null | undefined
    men_card_background_color: string | null | undefined
    men_card_opacity: number
    men_card_border_radius: number
    men_card_border_width: number
    men_card_border_color: string | null | undefined
    men_card_shadow_intensity: number
    men_last_visited: Date
    men_logo: string | null | undefined
    men_type: string | null | undefined
    men_poll_id: string | null | undefined

    totalPdfPages: number | null

    poll: Poll
}

export default Menu;